import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { useRootStore } from "../../../../store/contexts";
import { ShowMultiLine } from "../../../common/controls";
import { ShowReference } from "../../../common/controls";
import { InputCodeEditor } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type ReportViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  nameValue?: { displayId: string; id: string } | null;
  name: string;
  reportTypeValue: { displayId: string; id: string } | null;
  templateValue?: { displayId: string; id: string } | null;
  template: string;
  constantsValue?: { displayId: string; id: string } | null;
  constants: string;
  descriptionValue?: { displayId: string; id: string } | null;
  description: string;
};

export const ReportViewForm: React.FC<ReportViewFormProps> = observer(
  ({
    onPrint = () => {},
    onCancel = () => {},
    onEdit,
    showToolbox = true,
    name = "",
    reportTypeValue,
    template = "",
    constants = "",
    description = "",
  }) => {
    const rootStore = useRootStore();
    const { langStore } = rootStore;

    const componentRef = useRef(null);
    const handlePrint = useReactToPrint({
      content: () => componentRef.current,
    });

    return (
      <Grid>
        {showToolbox && (
          <FormToolbox
            editForm={onEdit}
            printForm={() => onPrint(handlePrint)}
            closeForm={() => onCancel()}
          />
        )}
        <Box ref={componentRef}>
          <GroupContainer
            id="null"
            title={langStore.groupReportLabel}
            collapsible={false}
          >
            <FormControl fullWidth>
              <ShowMultiLine value={name} label={langStore.ReportNameLabel} />
              <ShowReference
                label={langStore.ReportReportTypeLabel}
                selectedValue={langStore.displayIdByLang(
                  reportTypeValue?.displayId
                )}
              />
              <InputCodeEditor
                value={template}
                onChange={() => {}}
                label={langStore.ReportTemplateLabel}
                language="nunjucks"
                readOnly={true}
              />
              <InputCodeEditor
                value={constants}
                onChange={() => {}}
                label={langStore.ReportConstantsLabel}
                language="json"
                readOnly={true}
              />

              <ShowMultiLine
                value={description}
                label={langStore.ReportDescriptionLabel}
              />
            </FormControl>
          </GroupContainer>
        </Box>
      </Grid>
    );
  }
);
